import React, { ReactNode } from "react";
import { styled, Alert } from "@mui/material";
import { ClinicColors } from "fe-web-components/styles/clinicTheme";

//region [[ Styles ]]
const OnboardLayoutView = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  fontFamily: "inherit",
  color: ClinicColors.titles,
  paddingBottom: 50,
}));

const Title = styled("h3")({
  fontSize: 24,
  margin: "18px 0",
  textAlign: "center",
  fontWeight: 700,
  position: "relative",
  width: "100%",
  maxWidth: 630,
});
const ContentBox = styled("div")(({ theme }) => ({
  background: "#FFFFFF",
  boxShadow: "0px 0px 35px rgba(0, 0, 0, 0.06)",
  borderRadius: 8,
  padding: 50,
  width: "100%",
  maxWidth: 630,
  fontSize: 18,
  lineHeight: 1.5,
  position: "relative",
  [theme.breakpoints.down("xs")]: {
    fontSize: 16,
    padding: 30,
  },
  "& .submit-button": {
    marginTop: theme.spacing(2),
  },
}));
const Footer = styled("div")({
  marginTop: 60,
  fontSize: 14,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicOnboardViewProps {
  className?: string;
  title?: string | React.ReactNode;
  steps?: string[];
  currentStep?: number;
  children?: ReactNode;
  errMsg?: string;
  footerContent?: ReactNode;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicOnboardView = ({
  title,
  children,
  footerContent,
  errMsg,
}: ClinicOnboardViewProps) => {
  return (
    <OnboardLayoutView className="onboard-layout-view">
      <Title className="onboard-title">{title}</Title>
      <ContentBox className="onboard-box">
        {errMsg && <Alert severity="error">{errMsg}</Alert>}
        {children}
        {footerContent && <Footer>{footerContent}</Footer>}
      </ContentBox>
    </OnboardLayoutView>
  );
};
